
export default {
  inputStyle: {
    boxSizing: 'border-box',
    display: 'inline-block',
    position: 'relative',
    zIndex: 1,
    fontSize: '16px',
    lineHeight: '21px',
    height: '32px',
    width: '100%',
    padding: '0px 10px 0px 10px',
    backgroundColor: '#fff',
    color: '#000',
    border: '1px solid #aaa'
  },
  inputStyleHover: {
    boxShadow: 'inset 1px 1px 2px rgba(0,0,0,0.1)'
  },
  padStyle: {
    boxSizing: 'border-box',
    display: 'inline-block',
    margin: 0,
    padding: 0,
    outline: 'none',
    position: 'absolute',
    zIndex: 2,
    right: '10px',
    textAlign: 'right',
    lineHeight: '32px',
    color: '#aaa'
  },
  containerStyle: {
    width: '300px',
    position: 'relative',
    display: 'inline-block',
    zIndex: 1
  },
  disabled: {
    backgroundColor: '#ddd',
  },
  half: {
    width: '150px'
  },
  overHalf: {
    width: '210px'
  }
};



// WEBPACK FOOTER //
// ./src/Components/Input/style.js